module.exports = __webpack_public_path__ + "static/media/list-placeholder.a904b57e.png";